import { ReactNode } from 'react';

import { Text, useColorModeValue } from '@ecoinvent/ui';

type TooltipHeaderProps = {
  children: ReactNode;
};

const TooltipHeader = ({ children }: TooltipHeaderProps) => (
  <Text fontWeight="bold" color={useColorModeValue('white', undefined)}>
    {children}
  </Text>
);

export default TooltipHeader;
